import { isProductInCategory, products } from "./products";

const bottleSkus = new Set(["KL-SBT-PL", "KL-FBT-GL", "KL-SBT-GL"]);

// Confirmed customization capabilities for the actual catalog. Empty bottles
// and wool dryer balls have their own options instead of fragrance/formulation.
export const customizationBySku = Object.fromEntries(products.map(product => {
  const isBottle = bottleSkus.has(product.sku);
  const isWoolDryerBalls = product.sku === "KL-WDB-RG";
  const isKit = isProductInCategory(product, "kit");
  const isSheetProduct = isProductInCategory(product, "sheets") || product.sku === "KL-LDS-VM";
  const existingCategories = product.detailSections?.find(section => section.type === "customization")?.categories || [];
  const categories = [];

  if (!isBottle && !isWoolDryerBalls) {
    categories.push({
      id: "fragrance",
      title: "Fragrance",
      description: "Discuss a stock fragrance, a custom scent direction or a fragrance-free formula for your product.",
      items: ["Existing Klean Leaf fragrance options", "Custom fragrance development", "Fragrance-free formula review"],
      note: "Custom fragrances have a separate minimum order quantity.",
    }, {
      id: "formulation",
      tabLabel: "Product",
      title: isKit ? "Formulation & Bottle Size" : isSheetProduct ? "Formulation & Sheet Format" : "Formulation",
      description: isKit
        ? "Customize the ingredients and formulation of the cleaning products in your kit, and choose the bottle capacity that suits your range."
        : "Discuss ingredient preferences and formulation requirements for your product.",
      items: [
        isKit ? "Cleaning product ingredient and formulation customization" : "Ingredient and formulation customization",
        ...(isSheetProduct ? ["Sheet dimensions", "Perforated sheet formats", "Sheets per retail package"] : []),
        ...(isKit ? ["Bottle capacity options: 8 oz, 10 oz, 12 oz, 16 oz and more"] : []),
      ],
      image: existingCategories.find(category => category.id === "specifications")?.image,
    });
  } else if (isWoolDryerBalls) {
    categories.push({
      id: "color",
      title: "Color",
      description: "Discuss your preferred wool dryer ball colors with our team.",
      items: ["Custom color options"],
    });
  }

  categories.push({
    id: "artwork",
    tabLabel: "Packaging",
    title: "Packaging & Artwork",
    description: "Discuss the available packaging formats for this product, with artwork and carton planning for your brand.",
    items: ["Packaging format and dimensions", "Artwork integration and packaging samples", "Outer carton planning"],
    note: "Contact our team to confirm the quantity or volume per package, and we will send you the packaging dieline for your artwork.",
    image: existingCategories.find(category => category.id === "artwork")?.image,
  });

  return [product.sku, {
    id: "customization",
    type: "customization",
    enabled: true,
    description: isBottle
      ? "Plan the packaging and artwork for your bottle range."
      : isWoolDryerBalls
        ? "Choose colors and packaging for your wool dryer ball range."
        : isKit
          ? "Build your kit around your preferred fragrance, cleaning formulation, bottle capacity and retail presentation."
          : isSheetProduct
            ? "Build a product brief around your fragrance, formulation, sheet format and retail presentation."
            : "Build a product brief around your fragrance, formulation and retail presentation.",
    categories,
    note: isBottle || isWoolDryerBalls
      ? "Contact our team to confirm customization options and MOQ requirements for your project."
      : "Custom formulations are subject to technical review, testing, and MOQ requirements.",
    cta: { label: "Discuss Your Customization" },
  }];
}));
